module.exports = __webpack_public_path__ + "img/profile_user.e2862a26.jpg";